import { Edit, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";

const EditAccommodationOrder = () => (
  <Edit
    title="Редактиране на настанителна заповед"
    mutationMode="pessimistic"
    transform={({ accommodationId, number }) => ({ accommodationId, number })}
    actions={<BackButtonToolbar />}
  >
    <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
      <SaveForm />
    </SimpleForm>
  </Edit>
);

export default EditAccommodationOrder;
